import Env from "./env";

export const msalConfig = {
  auth: {
    clientId: Env.CLIENT_ID,
    authority: `https://login.microsoftonline.com/${Env.TENANT_ID}`,
    redirectUri: Env.REDIRECT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const protectedResources = {
  graphMe: {
    endpoint: Env.MICROSOFT_GRAPH_ME_ENDPOINT,
    scopes: ["User.Read"],
  },
};
